var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.prefixClass + "-quick-jumper")},[_vm._ssrNode(_vm._ssrEscape(_vm._s(_vm.gotoText))+"<input type=\"text\""+(_vm._ssrAttr("value",(_vm.page$)))+" class=\"input\">"+_vm._ssrEscape(_vm._s(_vm.pText)))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cd7d07c","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/pager/elevator.vue
// module id = 755
// module chunks = 0 1 10